"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTokenInjector = createTokenInjector;
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
function createTokenInjector(_ref) {
  let {
    tokens,
    namespace,
    supportedThemes
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    const invalidNameCharacters = /[^\w-]/;
    if (invalidNameCharacters.test(namespace)) {
      console.warn(`createTokenInjector: the namespace "${namespace}" can only contain characters allowed in css custom properties.`);
    }
    const set = new Set();
    for (const {
      name
    } of tokens) {
      if (set.has(name)) {
        console.warn(`createTokenInjector: duplicate token name found: "${name}".`);
      }
      if (invalidNameCharacters.test(name)) {
        console.warn(`createTokenInjector: the token "${name}" can only contain characters allowed in css custom properties.`);
      }
      set.add(name);
    }
  }

  // Create 2 things:
  // 1) a set of css custom properties to pass along to the injector, keyed by the supported
  //    theme names.
  const cssCustomPropertiesByThemeKey = {};
  // 2) a dictionary of token names => the CSS custom property names from #1.
  const tokenNameLookup = {};
  for (const themeKey of supportedThemes) {
    cssCustomPropertiesByThemeKey[themeKey] = {};
  }
  for (const token of tokens) {
    const tokenVariableName = `--smar--${namespace}--${token.name}`;
    // insert the variable name into the by-token-name lookup table.
    tokenNameLookup[token.name] = tokenVariableName;
    for (const [themeName, tokenValue] of Object.entries(token.value)) {
      // If the token doesn't have a value, skip it. This means it doesn't get injected into
      // the DOM later and will allow custom properties to cascade properly.
      // Ex:
      // var(--some-property, "fallback-value") only works if --some-property is not defined.
      if (tokenValue) {
        // Insert the css custom property into the map for the DOM.
        const thisThemesVariables = cssCustomPropertiesByThemeKey[themeName];
        thisThemesVariables[tokenVariableName] = tokenValue;
      }
    }
  }
  return {
    getToken: (name, fallbackValue) => `var(${tokenNameLookup[name]}${fallbackValue ? `, ${fallbackValue}` : ""})`,
    Injector: _ref2 => {
      let {
        themeKey
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(_core.Global, {
        styles: {
          ":root": cssCustomPropertiesByThemeKey[themeKey]
        }
      });
    }
  };
}
//# sourceMappingURL=createTokenInjector.js.map